/**
 * 记录地图相关信息
 */
import { initCommonChecks } from '@/components/Datacom/data';
import { defineStore } from 'pinia'
import { ref } from 'vue';

export const useVisibleChannelStore = defineStore('visibleChannelStore', () => {
    let showChannelModule=false;//显示模态框

    const getLocalStorageItem = (key: string, defaultValue: any):any => {
        const storedValue = localStorage.getItem(key);  
        if (!storedValue) {  
            return defaultValue;  
        }  
        try {  
            if(storedValue === '1'){
                return true;
            }else if(storedValue === '0'){
                return false;
            }else{
                return JSON.parse(storedValue);
            }
        } catch (error) {  
            return defaultValue;
        }  
    };
    let showChannelMap = ref({
        globalMap: getLocalStorageItem('GlobalMap_local', true),
        localMap: getLocalStorageItem('localMap_local', false),
        virtualLane: getLocalStorageItem('virtualLane_local', false),
        obstaclLabelStatic: getLocalStorageItem('obstacl_label_local_static', false),
        crossWalk: getLocalStorageItem('cross_walk_local', false),
        gpsTrajectory: getLocalStorageItem('gps_trajectory_local', true),
        freeArea: getLocalStorageItem('freeArea_enabled', false),
        ganzhiChecks:getLocalStorageItem('ganzhiConfig_checks', false)||['/ganzhiConfig/ObstacleNegType/0',
            '/ganzhiConfig/ObstacleNegType/1',
            '/ganzhiConfig/ObstacleNegType/2',
            '/ganzhiConfig/ObstacleNegType/3',
            '/ganzhiConfig/ObstacleNegType/4'],
    })

    let config_CommonListChecks = ref(getLocalStorageItem('config_CommonListChecks', initCommonChecks));
    let topicChannelChecks = ref(getLocalStorageItem('topicChannelChecks', ''))

    const setGlobalMap = (status:any)=>{
        showChannelMap.value.globalMap =  status;
    }
    const setLocalMap = (status:any)=>{
        showChannelMap.value.localMap =  status;
    }
    const setVirtualLane = (status:any)=>{
        showChannelMap.value.virtualLane =  status;
    }
    const setConfig_CommonListChecks = (checks:any)=>{
        config_CommonListChecks.value  = checks;
    }
    const setCrossWalk = (status:any)=>{
        showChannelMap.value.crossWalk =  status;
    }
    const setObstaclLabelStatic= (status:any)=>{
        showChannelMap.value.obstaclLabelStatic =  status;
    }
    const setTopicChannelChecks= (checks:any)=>{
        topicChannelChecks.value = checks;
    }
    
    const setGanzhilChecks= (checks:any)=>{
        showChannelMap.value.ganzhiChecks = checks;
    }
    
    const setGpsTrajectory = (status:any)=>{
        showChannelMap.value.gpsTrajectory = status;
    }

    const setFreeArea = (status:any)=>{
        showChannelMap.value.freeArea = status;
    }

    return { 
        showChannelMap,
        showChannelModule,
        config_CommonListChecks,
        setGlobalMap,
        setLocalMap,
        setVirtualLane,
        setConfig_CommonListChecks,
        setCrossWalk,
        setObstaclLabelStatic,
        setTopicChannelChecks,
        setGanzhilChecks,
        setGpsTrajectory,
        setFreeArea,
    }
})